import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { analytics } from "@/lib/analytics";

/**
 * Fires `analytics.pageView` whenever the route pathname changes.
 * Replaces the legacy GAListener / ReactGA.pageview wiring.
 */
export function useRouteAnalytics(): void {
  const location = useLocation();

  useEffect(() => {
    analytics.pageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
}
